import { cn } from 'lib/helpers/utility';

import DocText from 'components/shared/DocumentSheet/DocText';
import { DOC_TEXT } from 'components/shared/DocumentSheet/lib/docStyles';
import DocTable from 'components/shared/DocumentSheet/components/DocTable';
import DocSectionBanner from 'components/shared/DocumentSheet/components/DocSectionBanner';

import InvoiceDocBottom from '../components/InvoiceDocBottom';
import InvoiceDocBilledTo from '../components/InvoiceDocBilledTo';

const TABLE_PROPS = {
  rowPadClass: 'py-1.5',
  headerPadClass: 'pb-1.5',
  gutterClass: 'px-[3px]',
  firstGutterClass: 'pr-1.5',
  className: 'mt-2'
};

export const sectionBlock = ({ key, copy, table }) => ({
  key: `section-${key}`,
  leading: <DocSectionBanner title={copy.title} subtitle={copy.subtitle} className="mt-4" />,
  continuedLeading: (
    <DocText variant="label" size="small" className={cn(DOC_TEXT.microLabel, 'mt-4')}>
      {`${copy.title} · continued from the previous page`.toUpperCase()}
    </DocText>
  ),
  table,
  render: (props) => (
    <div className="overflow-x-auto print:overflow-visible">
      <div className="min-w-[640px] print:min-w-0">
        <DocTable {...props} {...TABLE_PROPS} />
      </div>
    </div>
  )
});

export const buildInvoiceBlocks = ({
  party,
  billedToAction,
  billedToDueDate,
  dueDate,
  sections,
  legend,
  memo,
  disclaimer,
  aging,
  summaryRows,
  summaryFootnote,
  amountDue
}) =>
  [
    {
      key: 'billed-to',
      node: <InvoiceDocBilledTo party={party} date={billedToDueDate} action={billedToAction} />
    },
    ...sections.map(sectionBlock),
    legend && {
      key: 'legend',
      node: (
        <DocText size="xs" className={cn(DOC_TEXT.legend, 'mt-1.5')}>
          {legend}
        </DocText>
      )
    },
    {
      key: 'bottom',
      node: (
        <InvoiceDocBottom
          memo={memo}
          disclaimer={disclaimer}
          aging={aging}
          rows={summaryRows}
          footnote={summaryFootnote}
          amountDue={amountDue}
          dueDate={dueDate}
        />
      )
    }
  ].filter(Boolean);
